import React from "react";
import {ListItemProps} from "@progress/kendo-react-dropdowns";
import FlintDropDownList, {FlintDropDownListProps} from "@components/controls/FlintDropDownList";
import {NameWithId} from "@utils/Models";
import {formatColourTypeLabel} from "@pages/orders/preview/recipes/colourTypeLabel";

const swatchStyle = (color: string | undefined): React.CSSProperties => ({
    background: color ?? "transparent",
    borderRadius: "50%",
    width: "1.3em",
    height: "1.3em",
    marginRight: "1em",
    outline: "1px solid #cacaca",
    float: "left",
});

function itemRender(li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) {
    const itemChildren = (
        <span>
            <span style={swatchStyle(itemProps.dataItem?.Extension)}/>
            {formatColourTypeLabel(itemProps.dataItem)}
        </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
}

function valueRender(element: React.ReactElement<HTMLSpanElement>, value: NameWithId | null) {
    if (!value || !value.Id) return element;
    const children = [
        <span key={1} style={swatchStyle(value.Extension)}/>,
        <span key={2}>&nbsp; {formatColourTypeLabel(value)}</span>
    ];
    return React.cloneElement(element, {...element.props}, children);
}

export default function ColourTypeDropdownList(props: ColourTypeDropdownListProps) {
    return (
        <FlintDropDownList<NameWithId>
            {...props}
            itemRender={itemRender}
            valueRender={valueRender}
        />
    );
}

export interface ColourTypeDropdownListProps extends Omit<FlintDropDownListProps<NameWithId>, "itemRender" | "valueRender" | "translateName" | "useHtmlTemplate"> {}
